import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.string.link.js";
import Card from '~/components/cards/Card.vue';
import WebpPicture from '~/components/WebpPicture.vue';
import { useCourseLandingStore } from '~/stores/courseLanding';
import blockProperty from '~/utilities/blockProperty';
import socialIcon from '~/utilities/socialIcon';
import { toParagraphsArray } from '~/utilities/paragraphs';
export default {
  __name: 'School',
  props: {
    block: Object,
    edit: Boolean
  },
  setup: function setup(__props) {
    var props = __props;
    var courseLandingStore = useCourseLandingStore();
    var locale = computed(function () {
      return courseLandingStore.locale;
    });
    var uid = ref(1);
    var blockImage = computed(function () {
      return blockProperty(props.block.image, 'src');
    });
    var blockTitle = computed(function () {
      return blockProperty(props.block.title, 'text');
    });
    var blockDesc = computed(function () {
      return blockProperty(props.block.description, 'text');
    });
    var blockLink = computed(function () {
      return blockProperty(props.block.link, 'href');
    });
    var blockSocials = computed(function () {
      return blockProperty(props.block.socials, 'items');
    });
    function icon(url) {
      return socialIcon(url);
    }
    ;
    function paragraphs(value) {
      return toParagraphsArray(value);
    }
    return {
      __sfc: true,
      courseLandingStore: courseLandingStore,
      locale: locale,
      props: props,
      uid: uid,
      blockImage: blockImage,
      blockTitle: blockTitle,
      blockDesc: blockDesc,
      blockLink: blockLink,
      blockSocials: blockSocials,
      icon: icon,
      paragraphs: paragraphs,
      Card: Card,
      WebpPicture: WebpPicture
    };
  }
};